












import { Component, Vue, Prop } from "vue-property-decorator";
import { IOAuthProvider } from "../../types/config.model";
import AuthProvider from "./AuthProvider.vue";

@Component({
  components: {
    AuthProvider,
  },
})
export default class AuthProviders extends Vue {
  @Prop({ required: true, type: Array }) oauthProviders!: IOAuthProvider[];
}
